/**
 * Formats a Date object into a human-readable string in the format: DD/MM/YYYY HH:MM AM/PM.
 * @param {Date} date - The date object to format. If the date is invalid, an empty string is returned.
 * @returns {string} - The formatted date string or an empty string if the date is invalid.
 */
export function getDateFormat2(date) {
  let date_return = "";
  if (isNaN(date.getTime())) {
    date_return = "";
  } else {
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let ampm;

    if (hours >= 12) {
      ampm = "pm";
    } else {
      ampm = "am";
    }
    hours = hours % 12 || 12;
    if (minutes < 10) {
      minutes = "0" + minutes;
    }

    let strTime = hours + ":" + minutes + " " + ampm;

    return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear() + " " + strTime;
  }

  return date_return;
}
